import { usePortalSubject } from '../contexts/PortalSubjectContext';

/**
 * Resolves the Patient id client-portal data should use (primary patient when logged in as guarantor proxy).
 * Now delegates to PortalSubjectContext (one portal account per login).
 */
export function usePortalSubjectPatientId(): string | undefined {
  const { activePatientId } = usePortalSubject();
  return activePatientId;
}

/**
 * Patient id for FHIR queries in the client portal: portal-subject (dependent) when set, otherwise the logged-in Patient id.
 * Now delegates to PortalSubjectContext.
 */
export function useEffectivePortalPatientId(): string | undefined {
  return usePortalSubjectPatientId();
}
